<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/active/list" color="blue">取消回上一頁</v-btn>
    </div>

    <v-form @submit.prevent="submit()" v-model="valid">
      <v-card flat tile class="mb-6">
        <v-card-text>
          <p class="title mb-6">新增活動</p>

            <v-text-field
              v-model="form.active_name"
              :rules="[formRules.required]"
              :persistent-hint="true"
              label="活動名稱"
              outlined
            ></v-text-field>

            <v-text-field
              type="text"
              v-model="form.active_code"
              :rules="[formRules.required]"
              hint="請輸入不重複的代碼，如序號為亂數取出，會加入次代碼在序號中"
              label="活動代碼"
              outlined
            ></v-text-field>
            <br>

            <v-select
              v-model="form.points"
              :items="itemsPoints"
              placeholder="序號金額"
              outlined>
            </v-select>

            <v-select
              v-model="form.weekday_type"
              :items="weekdayTypes"
              placeholder="正常/優惠時段使用"
              outlined>
            </v-select>

            <v-text-field
              type="number"
              v-model="form.hide_seconds"
              :persistent-hint="true"
              label="輸入後隱藏秒數"
              outlined
            ></v-text-field>


            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.start_time"
                  label="開始時間"
                  :rules="[formRules.required]"
                  readonly
                  v-on="on"
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.start_time" locale="zh-cn" color="blue"></v-date-picker>
            </v-menu>

            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.end_time"
                  label="結束時間"
                  :rules="[formRules.required]"
                  readonly
                  v-on="on"
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.end_time" locale="zh-cn" color="blue"></v-date-picker>
            </v-menu>


            <v-select
              v-model="form.available"
              :items="mappingAvailable"
              item-text="text"
              item-value="value"
              placeholder="啟用狀態"
              outlined
            ></v-select>
        </v-card-text>
      </v-card>

      <v-card-text>

        <v-select
          v-model="filterSerialNumber"
          :items="machineTypeList"
          item-text="text"
          item-value="value"
          solo
        ></v-select>

        <v-simple-table class="mb-6">
           <tr>
              <td colspan="3">
                   <a  color="teal" label="" @click="checkAll()">選擇全部</a>
                   &nbsp;&nbsp;&nbsp;&nbsp;
                   <a  color="teal" label="" @click="cancelAll()">取消全部</a>
              </td>
           </tr>
          <tbody>
            <tr
              v-for="item in machine_list"
              @click="checkbox(item)"
              :style="{ cursor: $hasHigherPermission ? 'default' : 'pointer' }"
              v-if="showMachine(item)"
            >
              <td>
                <v-checkbox v-model="item.allow_use" color="teal" @click.prevent></v-checkbox>
              </td>
              <td>{{ item.serial_number }}</td>
              <td>{{ item.name }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>

      <div class="text-center mb-6">
        <v-btn to="/deal/list" color="blue" class="mr-3">取消回上一頁</v-btn>
        <v-btn type="submit" :disabled="!valid" color="orange">確認新增</v-btn>
      </div>
    </v-form>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import DataMixin from "@/mixins/Data";

import activesApi from "@/api/actives";

export default {
  components: {},

  mixins: [DataMixin],

  props: [],
  data() {
    return {
      valid: false,

      filterSerialNumber: '',
      machine_list: [],
      itemsPoints: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100,160,170, 200, 240, 280, 300, 320],
      // weekdayTypes: [
      //   {text: "全時段使用",value: 0},
      //   {text: "優惠時段專用",value: 1},
      // ],
      form: {
        active_name: "",
        active_code: "",
        points: 30,
        start_time: "",
        end_time: "",
        available: true,
        allow_machine_ids: [],
        disable_machine_ids: []
      }
    };
  },

  computed: {
    $hasHigherPermission() {
        //return true;
        return [0, 300, 400].indexOf(this.roleId) === -1;
    }
  },
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    checkbox(item) {

      //console.log(this.$hasHigherPermission)

      // if (this.$hasHigherPermission) {
      //   return;
      // }

      item.allow_use = !item.allow_use;
    },

    checkAll(){
      this.machine_list.forEach(machine => {
        machine.allow_use=true;
      });
    },

    cancelAll(){
      this.machine_list.forEach(machine => {
        machine.allow_use=false;
      });
    },

    showMachine(item){
        if(this.filterSerialNumber == ''){
            return true;
        }
        else if(item.serial_number.substring(0,3) == this.filterSerialNumber){
            return true;
        }
        else {
            return false;
        }
    },

    submit() {

      this.form.allow_machine_ids = [];
      this.form.disable_machine_ids = [];

      this.machine_list.forEach(machine => {
        if (machine.allow_use && this.showMachine(machine) == true) {
            this.form.allow_machine_ids.push(machine.machine_id);
        }
        else{
            this.form.disable_machine_ids.push(machine.machine_id);
        }
      });

      if (!this.form.allow_machine_ids.length) {
        this.form.allow_machine_ids.push(0);
      }
      if (!this.form.disable_machine_ids.length) {
        this.form.disable_machine_ids.push(0);
      }

      // let postData = {
      //     active_name: this.tempData.active_name,
      //     active_code:  this.tempData.active_code,
      //     start_time: this.tempData.start_time,
      //     end_time: this.tempData.end_time,
      //     available: this.tempData.available,
      //     allow_machine_ids: this.allow_machine_ids,
      //     disable_machine_ids: disable_machine_ids,
      // };


      activesApi
        .create(this.form)
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });
          } else {
            this.$router.push("/active/list");
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    activesApi
      .getActiveToMachine(0)
      .then(res => {
        this.machine_list = res.data
      })
      .catch(err => {});

  }
};
</script>

<style lang="scss" scoped>
</style>
